import React, { useState } from 'react';
import PropTypes from 'prop-types';

import BrowserOnly from 'components/consumer/BrowserOnly';
import PDPCylindo3dViewer from 'components/consumer/PDP/PDPCylindo3dViewer';
import PDPMobileCarousel from 'components/consumer/PDP/PDPMobileCarousel';
import MobileModal from 'components/consumer/MobileModal';
import PDPDimensionsContent from 'components/consumer/PDP/PDPDimensionsContent';
import PDPDecideLaterOverlay from 'components/consumer/PDP/PDPDecideLaterOverlay';
import PDPMobileConfigurationPhotoGallery3dViewer from './PDPMobileConfigurationPhotoGallery3dViewer';
import PDPMobileDimensionsIcon from '../PDPMobileDimensionsIcon';

const PDPMobileConfigurationPhotoGalleryUI = ({
  isEditOrder = false,
  enableCrops = true,
  photos = [],
  productName,
  cylindoFeatures,
  isCylindoAvailable,
  showDecideLaterOverlay = false,
  isConfigFlipped = false,
  viewGalleryImageEvent,
}) => {
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  const [selectedCarouselIndex, setSelectedCarouselIndex] = useState(0);

  return (
    <div
      className="relative min-h-[100vw]"
      data-xc="PDPMobileConfigurationPhotoGalleryUI"
    >
      {isCylindoAvailable ? (
        <BrowserOnly>
          <PDPMobileConfigurationPhotoGallery3dViewer
            hidden={!isCylindoAvailable}
          >
            <PDPCylindo3dViewer cylindoFeatures={cylindoFeatures} isMobile />
          </PDPMobileConfigurationPhotoGallery3dViewer>
        </BrowserOnly>
      ) : (
        <PDPMobileCarousel
          isEditOrder={isEditOrder}
          enableCrops={enableCrops}
          photos={photos}
          productName={productName}
          showDecideLaterOverlay={showDecideLaterOverlay}
          setSelectedCarouselIndex={setSelectedCarouselIndex}
          selectedCarouselIndex={selectedCarouselIndex}
          onDimensionsIconClick={
            showDecideLaterOverlay
              ? () => {}
              : () => {
                  setIsDimensionsModalOpen(true);
                }
          }
          isConfigFlipped={isConfigFlipped}
          onAfterSlide={idx => {
            const photo = photos[idx];
            if (photo) {
              viewGalleryImageEvent({
                imageLocation: 'Configuration Gallery',
                imageFilename: photo.src?.split('/').pop() || '',
                totalImages: photos.length,
                position: idx,
              });
            }
          }}
        />
      )}

      {showDecideLaterOverlay && <PDPDecideLaterOverlay />}

      <MobileModal
        isOpen={isDimensionsModalOpen}
        title="Dimensions"
        isFullHeight
        onClose={() => {
          setIsDimensionsModalOpen(false);
        }}
      >
        <PDPDimensionsContent />
      </MobileModal>

      {/* Right-aligned dimensions icon button */}
      <div className="absolute right-4 top-4 z-[5] flex flex-col gap-2">
        <PDPMobileDimensionsIcon
          onClick={() => setIsDimensionsModalOpen(true)}
        />
      </div>
    </div>
  );
};

PDPMobileConfigurationPhotoGalleryUI.propTypes = {
  isEditOrder: PropTypes.bool,
  enableCrops: PropTypes.bool,
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
      src: PropTypes.string,
    })
  ),
  productName: PropTypes.string,
  isCylindoAvailable: PropTypes.bool,
  cylindoFeatures: PropTypes.arrayOf(PropTypes.string),
  showDecideLaterOverlay: PropTypes.bool,
  viewGalleryImageEvent: PropTypes.func,
  isConfigFlipped: PropTypes.bool,
};

export default PDPMobileConfigurationPhotoGalleryUI;
